<template>
  <div id="checkout-setting" class="shadow-md rounded-item">
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <h4 class=" text-2xl font-bold mb-6">Checkout Setting</h4>
          <div class="flex w-full">
            <div class="w-1/2 pr-3">
              <label>Checkout Type</label>
              <v-select v-model="selected" label="name" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false" :searchable="false" class="w-full mt-2"/><br>
            </div>
            <div class="w-1/2 pl-3" v-if="selected.type == 'auto' || selected.type == 'hybrid'">
              <label>Point Bonus</label>
              <vs-input class="inputx w-full mt-2" v-model="selected.point_bonus"/>
            </div>
          </div>
          <div class="flex align-center mt-6 justify-center">
            <vs-button color="primary" type="filled" @click="submitCheckoutConfig" style="min-width: 140px;">Save</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  name: 'vs-checkout-setting',
  components: {
    'v-select': vSelect,
  },
  data(){
    return{
       options: [
        {name: 'Auto Checkout', type: 'auto' , point_bonus : 0},
        {name: 'Manual Checkout', type: 'manual'},
        {name: 'Hybrid Checkout', type: 'hybrid' ,point_bonus: 0},
      ],
      selected: {},
      isOpenLoading: false,
      loaded_data_num: 0
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  computed:{
    checkoutConfig(){
      return this.$store.getters["appSetting/checkoutConfig"];
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Update checkout config failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Update checkout config failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    submitCheckoutConfig(){
      const obj = {
        type: this.selected.type,
        point_bonus: this.selected.point_bonus ? this.selected.point_bonus : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("appSetting/UPDATE_CHECKOUT_CONFIG" , obj).then(() => {
        this.closeLoading();
          this.$vs.notify({
          title:'Success',
          text:'Update Checkout Config Success',
          color:'success',
          position:'top-right'
        })
      }).catch(() => {
        this.closeLoading();
         this.$vs.notify({
          title:'Fail',
          text:'Update Checkout Config Failed',
          color:'danger',
          position:'top-right'
        })
      })
    }
  },
  created(){
    this.$store.dispatch("appSetting/GET_CHECKOUT_CONFIG").then(() => {
      let checkout = {};
      checkout = this.$store.getters["appSetting/checkoutConfig"];
      if(checkout.type == 'auto'){
        this.selected = {name: 'Auto Checkout', type: 'auto' , point_bonus: checkout.point_bonus}
      }
      if(checkout.type == 'manual'){
        this.selected = {name: 'Manual Checkout', type: 'manual'}
      }
      if(checkout.type == 'hybrid'){
        this.selected = {name: 'Hybrid Checkout', type: 'hybrid', point_bonus: checkout.point_bonus}
      }
      this.loaded_data_num++;
    })
  }
}
</script>